import React from 'react'

const CoreComponent17 = ({content}) => {
  return (
    <div>
        <div className=" row">
                    {content.map((val, i) => (
                      <div key={i} className="row mx-auto">
                        <div className="col-lg-6 text-center mb-3">
                          <img src={val.icon} style={{ width: "75%" }} alt="" />
                        </div>
                        <div className="col-lg-6 mt-3 mt-lg-0">
                          <h2 className='h2-heading lh-base'>{val.title} </h2>
                          <p className="mt-md-4 mt-2 h1-para lh-base">
                              {val.desc}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
    </div>
  )
}

export default CoreComponent17